import { keyframes } from "styled-components";
import { db } from "../Config";
const fechaACadena = (fecha) => {
  let f;
  if (
    !fecha ||
    fecha === null ||
    fecha === undefined ||
    fecha === "" ||
    isNaN(fecha)
  )
    f = new Date();
  else f = fecha;
  const a = f.getFullYear();
  const m = (f.getMonth() + 1).toString().padStart(2, "0");
  const d = f.getDate().toString().padStart(2, "0");
  return `${a}-${m}-${d}`;
};
export const fetchPacientes = (empresaId, query = "") => {
  return new Promise(async (resolve, reject) => {
    if (!empresaId || !query || query.trim() === "") {
      resolve([]);
      return;
    }
    const pacientesCollection = db
      .collection("empresas")
      .doc(empresaId)
      .collection("pacientes");
    const isNumeric = /^\d+$/.test(query);
    const isAlpha = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(query);
    let queryUpper = query.toUpperCase();
    let pacientes = [];
    try {
      if (isNumeric) {
        // Buscar por numDoc (empieza con)
        const snapshot = await pacientesCollection
          .where("empresaId", "==", empresaId)
          .orderBy("numDoc")
          .startAt(query)
          .endAt(query + "\uf8ff")
          .get();
        snapshot.forEach((doc) => {
          const data = doc.data();
          pacientes.push({
            id: doc.id,
            nombres: data.nombres,
            apellidos: data.apellidos ? data.apellidos : "",
            estado: data.estado ? data.estado : "S",
            fecNac: data.fecNac ? fechaACadena(data.fecNac.toDate()) : "",
            telefono: data.telefono,
            patologias: data.patologias ? data.patologias : [],
            tipDoc: data.tipDoc ? data.tipDoc : "DNI",
            direccion: data.direccion ? data.direccion : "",
            sexo: data.sexo,
            numDoc: data.numDoc,
            correo: data.correo,
            empresaId: data.empresaId,
          });
        });
      } else if (isAlpha) {
        // Buscar por nombres y apellidos (empieza con, usando mayúsculas)
        const [snapNombres, snapApellidos] = await Promise.all([
          pacientesCollection
            .where("empresaId", "==", empresaId)
            .orderBy("nombres")
            .startAt(queryUpper)
            .endAt(queryUpper + "\uf8ff")
            .get(),
          pacientesCollection
            .where("empresaId", "==", empresaId)
            .orderBy("apellidos")
            .startAt(queryUpper)
            .endAt(queryUpper + "\uf8ff")
            .get(),
        ]);
        const map = new Map();
        snapNombres.forEach((doc) => {
          const data = doc.data();
          map.set(doc.id, {
            id: doc.id,
            nombres: data.nombres,
            apellidos: data.apellidos ? data.apellidos : "",
            estado: data.estado ? data.estado : "S",
            fecNac: data.fecNac ? fechaACadena(data.fecNac.toDate()) : "",
            telefono: data.telefono,
            patologias: data.patologias ? data.patologias : [],
            tipDoc: data.tipDoc ? data.tipDoc : "DNI",
            direccion: data.direccion ? data.direccion : "",
            sexo: data.sexo,
            numDoc: data.numDoc,
            correo: data.correo,
            empresaId: data.empresaId,
          });
        });
        snapApellidos.forEach((doc) => {
          if (!map.has(doc.id)) {
            const data = doc.data();
            map.set(doc.id, {
              id: doc.id,
              nombres: data.nombres,
              apellidos: data.apellidos ? data.apellidos : "",
              estado: data.estado ? data.estado : "S",
              fecNac: data.fecNac ? fechaACadena(data.fecNac.toDate()) : "",
              telefono: data.telefono,
              patologias: data.patologias ? data.patologias : [],
              tipDoc: data.tipDoc ? data.tipDoc : "DNI",
              direccion: data.direccion ? data.direccion : "",
              sexo: data.sexo,
              numDoc: data.numDoc,
              correo: data.correo,
              empresaId: data.empresaId,
            });
          }
        });
        pacientes = Array.from(map.values());
      } else {
        // Si el query es mixto (letras y números), retornar vacío o puedes ajustar lógica según necesidad
        resolve([]);
        return;
      }
      resolve(pacientes);
    } catch (error) {
      reject(error);
    }
  });
};

export const getPaciente = (pacienteId, empresaId) => {
  return new Promise((resolve, reject) => {
    db.collection("empresas")
      .doc(empresaId)
      .collection("pacientes")
      .doc(pacienteId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          resolve({
            id: doc.id,
            nombres: doc.data().nombres,
            apellidos: doc.data().apellidos,
            estado: doc.data().estado,
            fecNac: fechaACadena(doc.data().fecNac.toDate()),
            telefono: doc.data().telefono,
            patologias: doc.data().patologias,
            tipDoc: doc.data().tipDoc,
            direccion: doc.data().direccion,
            numDoc: doc.data().numDoc,
            correo: doc.data().correo,
            empresaId: doc.data().empresaId,
          });
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const savePaciente = (paciente) => {
  return new Promise((resolve, reject) => {
    const pacienteRef = db
      .collection("empresas")
      .doc(paciente.empresaId)
      .collection("pacientes")
      .doc();
    paciente.id = pacienteRef.id;
    pacienteRef
      .set(paciente)
      .then(() => {
        resolve({ id: pacienteRef.id, ...paciente });
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getPacientesByIds = async (pacientesId, empresaId) => {
  let pacientes = [];
  for (let i = 0; i < pacientesId.length; i++) {
    let paciente = await getPaciente(pacientesId[i], empresaId);
    if (paciente) pacientes.push(paciente);
  }
  return pacientes;
};

export const getPacienteByNumdocAndEmpresaId = (numDoc, empresaId) => {
  return new Promise((resolve, reject) => {
    const pacientesCollection = db
      .collection("empresas")
      .doc(empresaId)
      .collection("pacientes");
    pacientesCollection
      .where("empresaId", "==", empresaId)
      .where("numDoc", "==", numDoc)
      .get()
      .then((querySnapshot) => {
        let paciente;

        querySnapshot.forEach((doc) => {
          paciente = {
            id: doc.id,
            nombres: doc.data().nombres,
            apellidos: doc.data().apellidos,
            estado: doc.data().estado,
            fecNac: fechaACadena(doc.data().fecNac.toDate()),
            telefono: doc.data().telefono,
            patologias: doc.data().patologias,
            tipDoc: doc.data().tipDoc,
            direccion: doc.data().direccion,
            numDoc: doc.data().numDoc,
            correo: doc.data().correo,
            empresaId: doc.data().empresaId,
          };
        });
        resolve(paciente);
        // Dispatch only when there are changes
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getPacientesCountByEmpresa = async (empresaId) => {
  let currentMonth = new Date().getMonth() + 1; // getMonth() returns 0-11
  let currentYear = new Date().getFullYear();
  let beginDate = new Date(currentYear, currentMonth - 1, 1);

  if (!empresaId) return 0;
  try {
    const snapshot = await db
      .collection("empresas")
      .doc(empresaId)
      .collection("pacientes")
      .where("empresaId", "==", empresaId)
      .where("created_at", ">=", beginDate)
      .get();
    return snapshot.size;
  } catch (error) {
    console.error("Error getting pacientes count:", error);
    return 0;
  }
};

export const getAllPacientesCountByEmpresa = async (empresaId) => {
  if (!empresaId) return 0;
  try {
    const snapshot = await db
      .collection("empresas")
      .doc(empresaId)
      .collection("pacientes")
      .where("empresaId", "==", empresaId)
      .get();
    return snapshot.size;
  } catch (error) {
    console.error("Error getting pacientes count:", error);
    return 0;
  }
};

/**
 * Funcion que dado la empresaId devuelve un arreglo de pacientes
 * @param empresaId
 *
 */
export const getPacientesByEmpresaId = async (empresaId) => {
  let pacientes = [];
  try {
    const snapshot = await db
      .collection("empresas")
      .doc(empresaId)
      .collection("pacientes")
      .where("empresaId", "==", empresaId)
      .orderBy("apellidos")
      .orderBy("nombres")
      .get();

    snapshot.forEach((doc) => {
      const data = doc.data();
      pacientes.push({
        id: doc.id,
        nombres: data.nombres,
        apellidos: data.apellidos ? data.apellidos : "",
        estado: data.estado ? data.estado : "S",
        fecNac: data.fecNac ? fechaACadena(data.fecNac.toDate()) : "",
        telefono: data.telefono,
        patologias: data.patologias ? data.patologias : [],
        tipDoc: data.tipDoc ? data.tipDoc : "DNI",
        direccion: data.direccion ? data.direccion : "",
        sexo: data.sexo,
        numDoc: data.numDoc,
        correo: data.correo,
        empresaId: data.empresaId,
      });
    });
    return pacientes;
  } catch (error) {
    console.error("Error getting patients by company:", error);
    return [];
  }
};
